import { NgModule, ModuleWithProviders } from '@angular/core';

import { PmdModalBackdrop } from './modal-backdrop.component';
import { PmdModal } from './modal.directive';
import { ModalTrap } from './modal-trap.directive';
import { PositioningService } from '../positioning';
import { ComponentLoaderFactory } from '../component-loader';
import { PmdModalContainer } from './modal-container.component';
import { PmdModalService } from './pmd-modal.service';

@NgModule({
  declarations: [
    PmdModalBackdrop,
    PmdModal,
    PmdModalContainer,
    ModalTrap
  ],
  exports: [PmdModalBackdrop, PmdModal, ModalTrap],
  entryComponents: [PmdModalBackdrop, PmdModalContainer]
})
export class PmdModalModule {
  static forRoot(): ModuleWithProviders<PmdModalModule> {
    return {
      ngModule: PmdModalModule,
      providers: [PmdModalService, ComponentLoaderFactory, PositioningService]
    };
  }
}
